import { CONTACT_TYPES_FRONT } from '@interlayer/js/app/components/main/MarketingPreferences/constants';
import { parseFieldsArrayToObject } from '@interlayer/js/app/components/main/Registration/utils/parseFieldsArrayToObject';

import { PreferencesProducts, TPreferencesFields } from './types';

export const PREFERENCES_FIELDS: TPreferencesFields[] = [
    'selectAll',
    `${PreferencesProducts.BINGO}_${CONTACT_TYPES_FRONT.email}`,
    `${PreferencesProducts.BINGO}_${CONTACT_TYPES_FRONT.SMS}`,
    `${PreferencesProducts.BINGO}_${CONTACT_TYPES_FRONT.phone}`,
    `${PreferencesProducts.BINGO}_${CONTACT_TYPES_FRONT.directMail}`,
    `${PreferencesProducts.CASINO}_${CONTACT_TYPES_FRONT.email}`,
    `${PreferencesProducts.CASINO}_${CONTACT_TYPES_FRONT.SMS}`,
    `${PreferencesProducts.CASINO}_${CONTACT_TYPES_FRONT.phone}`,
    `${PreferencesProducts.CASINO}_${CONTACT_TYPES_FRONT.directMail}`
];

export const PREFERENCES_DATA = parseFieldsArrayToObject(PREFERENCES_FIELDS, false);
